import Constant from '../constant/order/ShippingConstant';

const initialState = {
    isCreatingShipment: true,
    productQtys: false,
    associatedCustomer: null
};

export default function (state = initialState, action) {
    //console.log("🔥 Action recebida no reducer:", action);

    switch (action.type) {
        case Constant.ORDER_SET_IS_CREATING_SHIPMENT: {
            const { isCreatingShipment } = action;
            console.log("🔄 Atualizando isCreatingShipment:", isCreatingShipment);
            return { ...state, isCreatingShipment };
        }
        case Constant.ORDER_CREATE_SHIPMENT_LOAD_PRODUCT_QTYS_BEGIN: {
            const { associatedCustomer } = action;
            console.log("🔄 Atualizando associatedCustomer:", associatedCustomer);
            return { ...state, associatedCustomer };
        }
        case Constant.ORDER_CREATE_SHIPMENT_LOAD_PRODUCT_QTYS_AFTER: {
            const { productQtys } = action;
            console.log("🔄 Atualizando productQtys:", productQtys);
            return { ...state, productQtys };
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/extension/take-shipment/view/reducer/orderCreateShipmentReducer.js